/**
 * The Sign out button: ends the session everywhere it lives (#56). The server revokes the access token
 * (SEC-016), the identity provider's own session is ended (otherwise its cookie signs the next visitor straight
 * back in as this person), then the page drops the token and tells the shell, which removes every record from
 * the screen. Each remote step is best effort: with no connection the token runs out within its five minutes.
 */
import { api, SESSION_ENDED, setToken } from "./api.js";
import { endProviderSession } from "./auth.js";
import { REFRESH_KEY, sessionRefresher } from "./session.js";

export async function signOut(): Promise<void> {
  const refreshToken = sessionStorage.getItem(REFRESH_KEY);
  sessionRefresher.stop(); // renewal must not resurrect the session being ended
  await Promise.allSettled([api.post("/api/v1/me/logout"), endProviderSession(refreshToken)]);
  setToken(null);
  window.dispatchEvent(new Event(SESSION_ENDED));
}
